import { GROUP_AUDIENCE_LABEL } from 'src/modules/campaigns/helpers';
import {
  CampaignConfigSchema,
  FieldKey,
  FormMessage,
  MessageType,
  PayloadMessage,
} from '../../types';
import { isFieldVisible } from '../../helpers';
import { newClientKey } from '../../helpers/clientKey';
import { RecipientsBehaviour, whenVisible } from '../policy';

/** Shared field order used by the standard campaign types. */
export const standardFields = (
  config: CampaignConfigSchema,
  body: FieldKey[] = ['messages'],
): FieldKey[] => [
  'name',
  ...whenVisible(config.keywords, 'keywords'),
  ...whenVisible(config.recipients, 'recipients'),
  ...body,
  ...whenVisible(config.opt_out_message, 'optOut'),
];

export const inboundRecipients = (config: CampaignConfigSchema): RecipientsBehaviour => ({
  label: config.recipients?.label || GROUP_AUDIENCE_LABEL,
  groupTypes: 'default,custom',
  allowDynamicGroups: false,
  initialGroupType: 'custom',
});

export const isFlyer = (config: CampaignConfigSchema) => config.name === 'Text Flyer';

export const blankRecurringMessage = (type: MessageType): FormMessage => ({
  clientKey: newClientKey(),
  type,
  text: '',
  subject: '',
  links: [],
  position: 1,
  scheduledType: 'immediate',
  delay: null,
});

export const negated = (delay?: string | null): string | null =>
  (!delay ? null : delay.startsWith('-') ? delay : `-${delay}`);

export const hasErrors = (errors: Record<string, unknown>) => Object.keys(errors).length > 0;

/** Promote the first absolute message time to the campaign-level schedule. */
export const withCampaignDateSchedule = (
  messages: PayloadMessage[],
): { scheduledMessages: PayloadMessage[]; dateScheduled: string | null } => {
  const [first, ...rest] = messages;
  const dateScheduled = first?.scheduledType === 'time' ? first.time ?? null : null;
  return {
    dateScheduled,
    scheduledMessages: dateScheduled
      ? [{ ...first, scheduledType: 'immediate', time: null }, ...rest]
      : messages,
  };
};

export const optionalKeywords = (config: CampaignConfigSchema, ids?: string[]) =>
  (isFieldVisible(config.keywords) ? ids : undefined);
